import { gsap } from 'gsap';
import { DIRECTIONS } from '../constants';
import { degreesToRadians, getNumberAngle } from '../utils';
import { animationService } from './index';
import { roomsManagementHub } from '../roomsManagementHub';

export class Wheel {
  regularRotationAnimation = null;

  constructor() {
    //
  }

  startRegularRotationAnimation(direction = DIRECTIONS.RIGHT) {
    if (this.regularRotationAnimation) {
      return;
    }
    const wheelMesh = this.getWheelMesh();
    const directionMultiplier = this.getDirectionMultiplier(direction);
    const newYRotation = wheelMesh.rotation.y + directionMultiplier * Math.PI;

    this.regularRotationAnimation = gsap.to(wheelMesh.rotation, {
      y: newYRotation,
      duration: 2,
      ease: 'none',
      onComplete: () => {
        this.killRegularRotationAnimation();
        this.startRegularRotationAnimation(direction);
      },
    });
  }

  killRegularRotationAnimation() {
    if (this.regularRotationAnimation) {
      this.regularRotationAnimation.kill();
      this.regularRotationAnimation = null;
    }
  }

  getWheelMesh() {
    return roomsManagementHub.getCurrentRoomWheelMesh();
  }

  getWheelCollisionMesh() {
    return roomsManagementHub.getCurrentRoomsRouletteCollisionMesh();
  }

  getDirectionMultiplier(direction) {
    return direction === DIRECTIONS.RIGHT ? 1 : -1;
  }

  startRotationForSpin({ num, duration, direction, deviation }) {
    // right ++ left --
    this.killRegularRotationAnimation();
    const directionMultiplier = this.getDirectionMultiplier(direction);
    const wheelMesh = this.getWheelMesh();
    if (!wheelMesh) return;

    const a = degreesToRadians(getNumberAngle(num));
    const b = wheelMesh.rotation.y - (wheelMesh.rotation.y % (2 * Math.PI));
    const c = 12 * Math.PI;

    // const newYRotation = b - a - deviation + directionMultiplier * c - Math.PI / 2;
    // const difference = Math.abs(wheelMesh.rotation.y - newYRotation);

    let newYRotation, difference;

    newYRotation = b - a - deviation + directionMultiplier * c - Math.PI / 2;
    difference = Math.abs(wheelMesh.rotation.y - newYRotation);

    // console.log('*');
    // console.log('old: ', wheelMesh.rotation.y);
    // console.log('new: ', newYRotation);
    // console.log('difference: ', difference);

    const piForDuration = animationService.currentBall.animationDuration * (Math.PI / 2);

    console.log(`animatioDuration: ${animationService.currentBall.animationDuration}`);
    console.log(`piDifferenceRange: [${piForDuration - Math.PI} - ${piForDuration + Math.PI}]`);

    while (difference > piForDuration + Math.PI || difference < piForDuration - Math.PI) {
      newYRotation = newYRotation - directionMultiplier * 2 * Math.PI;
      difference = Math.abs(wheelMesh.rotation.y - newYRotation);
    }

    console.log('difference: ', difference);

    this.wheelSpecialRotationAnimation = gsap.to(wheelMesh.rotation, {
      y: newYRotation,
      duration,
      ease: 'none',
      onComplete: () => {
        this.wheelSpecialRotationAnimation = null;
        this.startRegularRotationAnimation(direction);
      },
    });
  }

  clearAnimations() {
    if (this.wheelSpecialRotationAnimation) {
      this.wheelSpecialRotationAnimation.progress(1);
      const wheelMesh = this.getWheelMesh();
      gsap.killTweensOf(wheelMesh.rotation);
      this.killRegularRotationAnimation();
      this.startRegularRotationAnimation(DIRECTIONS.RIGHT);
    }
  }
}
